import "./barprogress.sass";

export function BarProgress({ color = "#7A6BE8", size = 160 }) {
	return (
		<div className="skill" style={{ width: size, height: size }}>
			<div className="outer">
				<div className="inner">
					<div className="number">0%</div>
				</div>
			</div>
			<svg xmlns="http://www.w3.org/200/svg" version="1.1" width={size} height={size}>
				<circle cx="50%" cy="50%" r="43%" style={{ stroke: color }} strokeLinecap="round" />
			</svg>
		</div>
	);
}
